import { ONLY_NAME_REGEX } from "../../../../../../helpers/regex";

const validateName = (name) => {
  if (!name) return "Required";
  if (!ONLY_NAME_REGEX.test(name)) return "Only alphabets are allowed in name";
  return;
};

export default validateName;
